import { render, staticRenderFns } from "./HubPageRenderer.vue?vue&type=template&id=651b04c9&scoped=true&"
import script from "./HubPageRenderer.vue?vue&type=script&lang=js&"
export * from "./HubPageRenderer.vue?vue&type=script&lang=js&"
import style0 from "./HubPageRenderer.vue?vue&type=style&index=0&id=651b04c9&prod&lang=scss&"
import style1 from "./HubPageRenderer.vue?vue&type=style&index=1&id=651b04c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b04c9",
  null
  
)

export default component.exports